/* eslint @stylistic/key-spacing: ["error", {  "align": "value" }]*/

const CORPORATION_SCOPE_TYPE = {
    SCHOOLS:            'SCHOOLS',
    SCHOOL_AUTHORITIES: 'SCHOOL_AUTHORITIES',
}
export default CORPORATION_SCOPE_TYPE